import url from "../../../utils/api/url";
import Helper from "../../../utils/global/func";
import XLSX from "xlsx";
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "report-customer",
  data() {
    return {
      isLoading: false,
      isGenerating: false,
      isExporting: false,
      isGenerated: false,
      data: {
        customerGroups: this.$master?.customerGroups || [],
        customers: [],
        paymentMethods: this.$master?.paymentMethods || [],
        orderStatus: this.$master?.orderStatuses || [],
      },
      body: {
        customerGroupId: "",
        status: "",
        verified: "",
        orderStatus: "",
        startDate: "",
        endDate: "",
        startOrderDate: "",
        endOrderDate: "",
      },
      table: {
        name: "",
        headers: [],
        body: [],
      },
    };
  },
  components: { Multiselect, DatePicker },
  created() {},
  computed: {},
  methods: {
    getFullImage(path) {
      return Helper.getFullImage(path);
    },

    checkParamSign(param) {
      return param.includes("?") ? "&" : "?";
    },

    generateReport(type) {
      if (type == "export") this.isExporting = true;
      else this.isGenerating = true;

      let token = localStorage.getItem(this.$helper?.tokenEnum()?.access_token)
        ? localStorage.getItem(this.$helper?.tokenEnum()?.access_token)
        : "";

      let header = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      let param = "?download=true";
      let body = this.body;
      if (body.customerGroupId) {
        param = param + "&customerGroupId=" + body.customerGroupId;
      }
      if (body.status) {
        param = param + "&status=" + body.status;
      }
      if (body.verified) {
        param = param + "&verified=" + body.verified;
      }
      if (body.orderStatus) {
        param = param + "&orderStatus=" + body.orderStatus;
      }
      if (body.startDate) {
        param = param + "&startDate=" + body.startDate + "T00:00:00.000";
      }
      if (body.endDate) {
        param = param + "&endDate=" + body.endDate + "T23:59:59.999";
      }
      if (body.startOrderDate) {
        param =
          param + "&startOrderDate=" + body.startOrderDate + "T00:00:00.000";
      }
      if (body.endOrderDate) {
        param = param + "&endOrderDate=" + body.endOrderDate + "T23:59:59.999";
      }

      this.$axios({
        url: url.customerReport + param,
        method: "GET",
        headers: header.headers,
        responseType: "blob", // important
      })
        .then((response) => {
          this.isGenerated = true;
          if (response.statusCode) {
            if (response.statusCode === "403") {
              this.isGenerated = false;
              this.$toasted.show(response.message);
            }
          } else {
            const blobfile = new Blob([response.data]);

            if (type == "export") {
              this.isExporting = false;
              this.exportFile(blobfile);
            } else {
              this.isGenerating = false;
              this.readFileToTable(blobfile);
            }
          }
        })
        .catch(() => {
          this.isGenerating = false;
          this.isGenerated = false;
          this.$toasted.show("No Data");
        });
    },

    exportFile(blobfile) {
      const url = window.URL.createObjectURL(blobfile);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    readFileToTable(blobfile) {
      return new Promise((resolve, reject) => {
        this.table.headers.length = 0;
        this.table.body.length = 0;

        const reader = new FileReader();

        reader.onload = (event) => {
          try {
            const data = event.target?.result;

            if (!(data instanceof ArrayBuffer)) {
              throw new Error("Invalid Excel file data");
            }

            const workbook = XLSX.read(data, {
              type: "array",
              cellDates: true,
            });

            if (!workbook.SheetNames.length) {
              throw new Error("Excel file has no worksheets");
            }

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];

            if (!worksheet || !worksheet["!ref"]) {
              throw new Error("Worksheet is empty");
            }

            /**
             * Convert worksheet to a 2D array.
             *
             * Example:
             *
             * [
             *   ["Delivery Status", "Start Deliver Date", ...],
             *   ["Waiting To Deliver", "", ...],
             *   ["On Delivery", "24-Apr-2026 02:12 PM", ...]
             * ]
             */
            const rows = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              defval: "",
              raw: false,
            });

            if (!rows.length) {
              resolve({
                headers: [],
                body: [],
              });

              return;
            }

            const headers = rows[0].map((header) =>
              String(header ?? "").trim(),
            );

            const body = rows
              .slice(1)
              .filter((row) =>
                row.some(
                  (value) =>
                    value !== null &&
                    value !== undefined &&
                    String(value).trim() !== "",
                ),
              );

            this.table.headers.push(...headers);
            this.table.body.push(...body);

            resolve({
              headers,
              body,
            });
          } catch (error) {
            console.error("Failed to parse Excel file:", error);
            reject(error);
          }
        };

        reader.onerror = () => {
          const error = new Error("Failed to read Excel file");

          console.error(error);
          reject(error);
        };

        reader.readAsArrayBuffer(blobfile);
      });
    },

    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      let date = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds,
      );
      return moment(date).format("DD-MMM-YYYY h:mm A");
    },

    nullValue(string) {
      if (string == "") {
        string = "N/A";
      }
      return string;
    },
  },
};
